import LegalPage from "@/pages/legal/LegalPage";

export default function Terms() {
  return (
    <LegalPage title="Terms & Conditions" testId="page-terms">
      <p>
        These Terms &amp; Conditions (&quot;Terms&quot;) govern your access to and use of LeadGen (&quot;LeadGen&quot;,
        &quot;we&quot;, &quot;our&quot;, or &quot;us&quot;), including our website, web application, and the digital
        marketing plans generated by them (collectively, the &quot;Service&quot;). By using the Service you agree
        to be bound by these Terms. If you do not agree, please stop using the Service.
      </p>

      <h2>1. What LeadGen is</h2>
      <p>
        LeadGen is a self-serve software tool that reads a website you provide and generates an AI-assisted
        digital marketing plan — including a Growth Score, a prioritised list of today&apos;s actions, planning
        scenarios, keyword suggestions, ad copy, landing-page copy, a 30-day content calendar, retargeting
        suggestions, a weekly optimisation checklist and KPI benchmarks.
      </p>
      <p>
        Every forecast, lead count, cost per lead, ROAS or revenue figure shown anywhere in LeadGen is an
        <strong> illustrative planning scenario</strong> built on publicly available industry benchmark ranges
        (CTR, CVR, CPC). <strong>LeadGen does not guarantee any specific business outcome.</strong>
      </p>

      <h2>2. Your account and content</h2>
      <ul>
        <li>LeadGen is session-based; a browser identifier is stored locally so you can return to your plans.</li>
        <li>You are responsible for the website URL and any inputs you submit, and for ensuring you have the right to use them.</li>
        <li>You retain ownership of the business inputs you provide and the generated plan output on your account.</li>
      </ul>

      <h2>3. Acceptable use</h2>
      <ul>
        <li>You must not use LeadGen to generate plans for illegal, infringing, harmful or deceptive businesses.</li>
        <li>You must not scrape, resell, white-label or redistribute LeadGen&apos;s output as if it were your own tool.</li>
        <li>You must not attempt to reverse-engineer, overload, probe or disrupt the Service.</li>
      </ul>

      <h2>4. Pricing &amp; payments</h2>
      <p>
        Paid tiers are described on the <a href="/#pricing">Pricing</a> page. Payments are processed by Razorpay.
        Taxes may apply and will be shown at checkout where required by law. Prices may change; the price at the
        moment of purchase is the price you pay for that purchase. Please read the Cancellation &amp; Refunds page
        for refund terms.
      </p>

      <h2>5. Third-party services and AI output</h2>
      <p>
        LeadGen uses third-party AI providers (Anthropic Claude and OpenAI) to generate text. AI output may be
        incomplete, outdated, or factually wrong. You are responsible for reviewing every plan before executing it,
        and for complying with the advertising policies of Google, Meta, and any other platform you choose to run
        campaigns on.
      </p>

      <h2>6. Intellectual property</h2>
      <p>
        LeadGen, including its brand, source code, UI, and prompts, is owned by LeadGen. Nothing in these Terms
        grants you any right in LeadGen&apos;s intellectual property except the limited right to use the Service
        for your own business.
      </p>

      <h2>7. Disclaimer of warranties</h2>
      <p>
        The Service is provided &quot;as is&quot; and &quot;as available&quot;, without warranties of any kind,
        express or implied, including fitness for a particular purpose, non-infringement and accuracy of AI
        output.
      </p>

      <h2>8. Limitation of liability</h2>
      <p>
        To the maximum extent permitted by law, LeadGen will not be liable for any indirect, incidental, special,
        consequential or punitive damages, or for any loss of profit, revenue, or data, arising out of your use of
        the Service. Our total liability for any claim will not exceed the amount you paid us in the twelve months
        preceding the event giving rise to the claim.
      </p>

      <h2>9. Suspension and termination</h2>
      <p>
        We may suspend or terminate your access to the Service at any time if we reasonably believe you have
        violated these Terms or applicable law. You may stop using the Service at any time.
      </p>

      <h2>10. Governing law</h2>
      <p>
        These Terms are governed by the laws of India. Any dispute will be subject to the exclusive jurisdiction
        of the courts of India.
      </p>

      <h2>11. Changes to these Terms</h2>
      <p>
        We may update these Terms from time to time. Material changes will be reflected on this page with a new
        &quot;Last updated&quot; date.
      </p>

      <h2>12. Contact</h2>
      <p>
        Questions about these Terms? Email <a href="mailto:madwithppc@gmail.com">madwithppc@gmail.com</a>.
      </p>
    </LegalPage>
  );
}
